import { z } from 'zod';

const Email = z
  .string()
  .refine(
    (email) => email.split('').filter((char) => char === '@').length === 1,
  );
export type Email = z.infer<typeof Email>;

export function isEmail(value: unknown): value is Email {
  return Email.safeParse(value).success;
}
